import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { documentResponseSchema } from '../../../common/validations/document'

import { get } from 'api/apiClient'

const params = (contractUUID: string) => ({
  queryKey: [`${API_ENDPOINTS.CONTRACTS}/${contractUUID}/documents`],
  queryFn: () =>
    get(
      `${API_ENDPOINTS.CONTRACTS}/${contractUUID}/documents`,
      documentResponseSchema
    ),
})

export const useAPIGetContractDocuments = (contractUUID: string) =>
  useQuery(params(contractUUID))

export const useAPIGetContractDocumentsSuspense = (contractUUID: string) =>
  useSuspenseQuery(params(contractUUID))
